// TODO: Este componente solo ha sido creado para tener la estructura
// queda pendiente de adaptar a la necesidades del proyecto
import genericSvgIcon from 'js/components/_moverick/generic-svg-icon'

import template from './index.pug'

export default Vue.extend({
  name: 'card',
  template: template(),
  components: {
    genericSvgIcon
  },

  props: {
    card: {
      type: Object,
      required: true
    }
  },

  data() {
    return {

    }
  },
  computed: {
  }
})
